import { useImmerAtom } from 'jotai-immer';
import { editStateAtom } from '../payor_edit_atoms';
import { EditStateHook } from '../payor_edit_types';
import { useCallback } from 'react';

export const usePayorEditState = (): EditStateHook => {
    const [state, setState] = useImmerAtom(editStateAtom);

    const setWait = useCallback(
        (wait: boolean): void => {
            setState(draft => {
                draft.waiting = !!wait;
            });
        },
        [setState],
    );

    return {
        init: state.init,
        waiting: state.waiting,
        setWait,
    };
};
